const MuiAlert = {
  root: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr auto 1fr',
    opacity: 0.85
  },
  icon: {
    justifySelf: 'end',
    marginTop: -3,
    marginBottom: -3,
    '& .MuiSvgIcon-root': {
      fontSize: 28
    }
  },
  message: {
    justifySelf: 'center'
  },
  action: {
    marginLeft: 0,
    justifySelf: 'end'
  }
};
export default MuiAlert;